export enum RouteNames {
  HOME = "HOME",
  ERLAUBNISKARTEN = "ERLAUBNISKARTEN",
  FAHRBEWILLIGUNGEN = "FAHRBEWILLIGUNGEN",
}
